import React from "react";
import {
  QrDownloadButtonStyled,
  QrDownloadStyled,
} from "./QrDownloadButtonStyled";

export const QrDownloadButton = (props) => {
  const { children, href, icon, bg, color, qrcode, ...rest } = props;
  const handleClick = () => {
    window.open(href, "_blank", "noopener noreferrer");
  };
  return (
    <QrDownloadButtonStyled
      {...rest}
      onClick={handleClick}
      background={bg}
      color={color}
    >
      {qrcode ? (
        <QrDownloadStyled background={bg} color={color}>
          <div>
            <p>SCAN ME</p>
            <img src={qrcode} alt="qrcode" loading="lazy" />
          </div>
        </QrDownloadStyled>
      ) : null}

      <div>
        {icon && icon}
        {children}
      </div>
    </QrDownloadButtonStyled>
  );
};
